import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import SymbolSearchPopup from "./SymbolSearchPopup";


export default function SetPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');

    const [symbolList, setSymbolList] = useState([]);

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
      if (!cookies.uuid) {
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/LoginAts`;
        return;
      } else {
        const uuid = cookies.uuid;
        fetchUserInfo(uuid);
      }
    }, []);

    useEffect(() => {
      console.log('클라이언트 uuid');
    }, [cookies.uuid]);
  
    const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setNickname(user.nickname);
          fetchLists(user.uid);
          const possible = user.pin_possible;
          const nickname = user.nickname
          if (possible === '0' || possible === null || possible === 0){
            alert(`${nickname} 님은 Revolution version의 사용권한이 없습니다.`)
            window.location.href = `/SelectPage`;
            return;
            }
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          window.location.href = `/LoginAts`;
          return;
        });
    };

    // selectedlevel, entry, waiting list 받아오기
    const fetchLists = (uid) => {
      fetch(`/startcheck/searchlevel?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          if(data[0].super_user === "8"){
            setLevelCheck(data[0].super_user);  
          }else{
            setLevelCheck(data[0].selectedLevel);
          }
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });

      fetch(`/startcheck_pin/list_entry?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, e_items, setE_Items);
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });
  
      fetch(`/startcheck_pin/list_wait?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, w_items, setW_Items);
        })
        .catch(error => {
          console.error('Waiting List 가져오기 오류:', error);
          alert(error);
        });
    };
  
    const updateList = (data, list, setList) => {
      for (let i = 0; i < data.length; i++) {
        if (!isItemInList(data[i].symbol, list)) {
          setList(prevList => [...prevList, data[i].symbol]);
        }
      }
    };

    const isItemInList = (item, list) => {
      return list.includes(item);
    };

    const[symbol,setSymbol] = useState('default');

    const[direction,setDirection] = useState('both');
    const[leverage_info, setLeverage] = useState(10);
    const[entry_usdt, setEntryUsdt] = useState(0);

    const[position_mode,setPositionMode] = useState('normal');
    const[benefit_ratio,setBenefitRatio] = useState(20);

    const[sensitivity,setSensitivity] = useState(10);
    const[atr_period,setAtrPeriod] = useState(1);

    const[entry_candle,setEntryCandle] = useState('30m');
    const[candle_type_entry, setCandleTypeEntry] = useState('haikin');
    const[entry_checking,setEntryChecking] = useState(-1);

    const[sensitivity_close,setSensitivityClose] = useState(10);
    const[atr_period_close,setAtrPeriodClose] = useState(1);

    const[close_type,setCloseType] = useState('kp');
    const[close_candle,setCloseCandle] = useState('30m');
    const[candle_type_close, setCandleTypeClose] = useState('haikin');
    const[close_checking,setCloseChecking] = useState(-1);

    //////////////////////////////////////////////////////////
    
    const[leverageValid,setLeverageValid] = useState(true);

    const[sensitivityValid, setSensitivityValid] = useState(true);
    const[atrperiodValid, setAtrperiodValid] = useState(true);

    const[sensitivityCloseValid, setSensitivityCloseValid] = useState(true);
    const[atrperiodCloseValid, setAtrperiodCloseValid] = useState(true);

    const[closecandlecountValid, setCloseCandleCountValid] = useState(true);
  
    const[benefitratioValid, setBenefitratioValid] = useState(true);

    const[entryusdtValid,setEntryUsdtValid] = useState(true);

    const[setlevel, setLevelCheck] = useState(0);
    const[notAllow, setNotAllow] = useState(true);

    const[e_items, setE_Items] = useState([]);
    const[w_items, setW_Items] = useState([]);

    const[search,setSearch] = useState(false);

    const[trade_start,setTradeStart] = useState(false);
    
    const[benefit_stop,setBenefit_stop] = useState(false);
    const[benefit_cancel,setBenefit_cancel] = useState(false);

    const[currentCoin_stop,setCurrentCoin_stop] = useState(false);
    const[allCoin_stop,setAllCoin_stop] = useState(false);

    const[end,setEnd] = useState(false);
    
    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //

    const handlePositionMode = (e) => {
      setPositionMode(e.target.value);
        };

    const handleEntryCandle = (e) => {
      setEntryCandle(e.target.value);
        };
    
    const handleCloseCandle = (e) => {
      setCloseCandle(e.target.value);
        };
    
    const handleDirection = (e) => {
      setDirection(e.target.value);
        };

    const handleEntryEntryChecking = (e) => {
      setEntryChecking(e.target.value);
        };
    
    const handleCloseType = (e) => {
      setCloseType(e.target.value);
        };

    const handleCloseChecking = (e) => {
      setCloseChecking(e.target.value);
        };
    
    const handleCandleTypeEntry = (e) => {
      setCandleTypeEntry(e.target.value);
        };
    
    const handleCandleTypeClose = (e) => {
      setCandleTypeClose(e.target.value);
        };
    
    const handleLeverage = (e) => {
      const newLeverage = e.target.value.trim();
      setLeverage(newLeverage);
        const regex = 
        /^\d*$/;
        if (regex.test(newLeverage)) {
          setLeverageValid(true);
          } 
        else {
          setLeverageValid(false);
          }
        };
    
    const handleSensitivity = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivity(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityValid(true);
          } 
        else {
          setSensitivityValid(false);
          }
        };
    
    const handleAtrperiod = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriod(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodValid(true);
          } 
        else {
          setAtrperiodValid(false);
          }
        };

    const handleSensitivityClose = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityClose(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityCloseValid(true);
          } 
        else {
          setSensitivityCloseValid(false);
          }
        };
    
    const handleAtrperiodClose = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodClose(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodCloseValid(true);
          } 
        else {
          setAtrperiodCloseValid(false);
          }
        };

    const handleBenefitratio = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitratioValid(true);
          } 
        else {
          setBenefitratioValid(false);
          }
        };
    
   
    const handleEntryUsdt = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid(true);
          } 
        else {
          setEntryUsdtValid(false);
          }
        };


    const handleAddSymbol = (symbol) => {
      const confirmed = window.confirm(`${symbol}을 리스트에 추가할까요?`);
      if (confirmed) {
      fetch(`/add_user_symbols_pin?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => {
        if (data.msg) {
            alert(data.msg); // msg가 존재할 때만 출력
            return;
          }
        setSymbolList(data.signal)
      })
      .catch(err => console.error(err));
      }
    };

    const deleteSymbol = (symbol) => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      const confirmed = window.confirm(`${symbol}이 포지션이 걸려 있다면 리스트에서 삭제 후 수동으로 포지션 정리해주세요! ${symbol}을 삭제하시겠습니까?`);
      if (confirmed) {
      fetch(`/delete_user_symbols_pin?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      removeListItem(symbol, setE_Items);
      removeListItem(symbol, setW_Items);
      setSymbol('default')
      }
    };

    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };        

    const addListItem = (newItem, listSetter) => {
      listSetter(prevList => [...prevList, newItem]);
    };

    const removeListItem = (itemName, listSetter) => {
      listSetter(prevList => prevList.filter(item => item !== itemName));
    };
    
    const onClickCoin = (coin) => {
      setSymbol(coin);
      onClickSearch(coin);
    }

    useEffect(() => {

      if(entryusdtValid && sensitivityValid && atrperiodValid && sensitivityCloseValid && atrperiodCloseValid && leverageValid && benefitratioValid && closecandlecountValid) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [entryusdtValid, sensitivityValid, atrperiodValid, sensitivityCloseValid, atrperiodCloseValid, leverageValid, benefitratioValid, closecandlecountValid]);

    useEffect(() => {
        fetch(`/get_user_symbols_pin?uid=${uid}`)
        .then(res => res.json())
        .then(data => setSymbolList(data.signal))
        .catch(err => console.error(err));
    },[symbol,uid]);

    const onClickSearch = (symbol) => {
      let urlName
      const str = symbol;
      console.log(str);
      const uidurl = uid;
      if(str === 'default'){
        urlName = 'default'
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
      fetch(`/setdata_pin/${uidurl}/${urlName}/${setlevel}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        console.log('db에서 성공적으로 데이터 받아옴');

        setPositionMode(result[0].position_mode);
        setLeverage(result[0].leverage_info);
        setBenefitRatio(result[0].benefit_ratio);

        setCloseCandle(result[0].close_candle);
        setDirection(result[0].direction);

        setSensitivity(result[0].sensitivity);
        setAtrPeriod(result[0].atr_period);

        setSensitivityClose(result[0].sensitivity_close);
        setAtrPeriodClose(result[0].atr_period_close);

        setEntryCandle(result[0].entry_candle);
        setEntryChecking(result[0].entry_checking);

        setCandleTypeEntry(result[0].candle_type_entry);
        setCandleTypeClose(result[0].candle_type_close);

        setCloseType(result[0].close_type);
        
        setCloseChecking(result[0].close_checking);

        setEntryUsdt(result[0].entry_usdt);

        setTradeStart(result[0].trade_start);
        setBenefit_stop(result[0].current_symbol_stop);
        setCurrentCoin_stop(result[0].current_coin_clear);
        setAllCoin_stop(result[0].all_coin_clear);
        setEnd(result[0].end);

        const e_checklist = isItemInList(result[0].symbol, e_items);
        const w_checklist = isItemInList(result[0].symbol, w_items);
        
        if(str !== 'default'){
          result.forEach(item => {
            // console.log('item',item)
            if ((item.trade_start === 1 || item.trade_start === '1') && e_checklist === false) {
              addListItem(item.symbol, setE_Items);
            }
            if ((item.trade_start === 0 || item.trade_start === '0') && e_checklist === true) {
              removeListItem(item.symbol, setE_Items);
            }
          
            // Waiting coin 리스트 삽입 및 삭제
            if ((item.current_symbol_stop === 1 || item.current_symbol_stop === '1') && w_checklist === false) {
              addListItem(item.symbol, setW_Items);
            }
            if ((item.current_symbol_stop === 0 || item.current_symbol_stop === '0') && w_checklist === true) {
              removeListItem(item.symbol, setW_Items);
            }
          });
        };

        console.log('e_items',e_items);
        console.log('e_checklist',e_checklist);
      })
      .catch((error) => {
        console.error('에러남:', error.message || error);
      })
    }

    const onClickStart = () => {

      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      let confirmed = false

      if (trade_start === 0 || trade_start === "0"){
        confirmed = window.confirm(symbol + '의 매매를 시작하시겠습니까?');
      }else if (trade_start === 1 || trade_start === "1"){
        confirmed = window.confirm(symbol + '의 셋팅값을 변경하시겠습니까?');
      }

      if (confirmed) {
        console.log('스타트 버튼 클릭')
        fetch('/start_pin', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            uid,
            symbol,
            position_mode,
            leverage_info,
            entry_usdt,
            benefit_ratio,
            close_candle,
            direction,
            sensitivity,
            atr_period,
            sensitivity_close,
            atr_period_close,
            entry_candle,
            entry_checking,
            close_type,
            candle_type_entry,
            candle_type_close,
            close_checking
            }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          onClickSearch(symbol);
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };

      onClickSearch(symbol);
    };

    // 익절 후 정리
    const onClickBenefit_stop = (symbol) => {
      const confirmed = window.confirm('Do you want to clean up the selected coin after profiting?');

      if (confirmed) {
        setBenefit_stop(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_pin/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
      onClickSearch(symbol);
    }

    // 익절 후 정리 취소 
    const onClickBenefit_cancel = (symbol) => {
      const confirmed = window.confirm('Do you want to cancel clearing after profiting the selected coins?');

      if (confirmed) {
        setBenefit_cancel(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_cancel_pin/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit_cancel에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    // 현재 코인 정리 
    const onClickCurrentCoin_stop = (symbol) => {
      const confirmed = window.confirm('Would you like to liquidate the selected coins right away?');

      if (confirmed) {
        setCurrentCoin_stop(true);
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_current_coin_clear_pin/${uidurl}/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }


    //로그아웃
    const onClickEnd = () => {
        const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
        if (!uuid) {
          alert('로그인 정보가 존재하지 않습니다.');
          return;
        }
        // 로그아웃 요청을 서버로 보냅니다.
        fetch('/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: uuid })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('로그아웃 요청 실패');
          }
          console.log('로그아웃 성공');
          alert('Logout is successful.');
          window.location.href = '/';
        })
        .catch(error => {
          console.error('로그아웃 요청 중 오류 발생:', error);
        });
      // UUID를 서버로 보내는 예시 코드

    }

    return (
        <div className="page_sp_leverage">
          <div className="title_top_sp">
            <div></div>
            <div className="titleWrap_sp_lever">
            Auto trade system (Pin version)</div>
            <div className="inputTitle_uid_lever">
                <span>UID : {uid}</span>
                <span>{nickname}님 환영합니다</span>
            </div>
          </div>

          <div className="line_top"></div>

            <div className="container">
              <div className="column_leverage">
              <div className="button_benefit_leverage">
              <select className="usdt_select_lv_samaria" 
                value = {symbol} 
                onChange={(e) => {setSymbol(e.target.value); 
                                  onClickSearch(e.target.value);}}>
                <option value="">symbol select</option>
                {symbolList.map((sym, idx) => (
                    <option key={idx} value={sym}>{sym}</option>
                ))}
              </select>
              <button onClick={() => setIsPopupOpen(true)} disabled={!symbol} className="button_benefit_c_ut">
                추 가
              </button>
              <button onClick={() => deleteSymbol(symbol)} disabled={!symbol} className="button_benefit_c_ut">
                삭 제
              </button>
              </div>
              {/* 팝업은 여기서 조건부 렌더링 */}
              <div>
                <SymbolSearchPopup
                  isOpen={isPopupOpen}
                  onAdd={handleAddSymbol}
                  onClose={handleClosePopup}
                  />
              </div>

            <div className="contentWrap_sp">

            <div className="line"></div>

            <div className="center_text_lever">Basic setting(PIN)</div>
              <div class="leverage_container">
                <div class="leverage_item">진입 방향</div>
                <select className="select_samaria" value={direction} onChange={handleDirection}>
                  <option value='both'>양방향</option>
                  <option value='long'>롱</option>
                  <option value='short'>숏</option>
                </select>
                <div class="leverage_item">Leverage set</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={leverage_info}
                  onChange={handleLeverage} />
                <div class="leverage_item">진입USDT</div>
                  <input
                  type="number"
                  class="leverage_input_basic"
                  value={entry_usdt}
                  onChange={handleEntryUsdt} />
                </div>

              <div class="leverage_container">
                <div class="leverage_item">청산모드 선택</div>
                  <select className="select_samaria"
                  value={position_mode} onChange={handlePositionMode}>
                  <option value="cross">교차모드</option>
                  <option value="isolated">격리모드</option>
                  </select>
                <div class="leverage_item">절대익절(%)</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={benefit_ratio}
                  onChange={handleBenefitratio} />
              </div>

              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item">진입기준</div>
                <div class="leverage_item">Sensitivity</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={sensitivity}
                onChange={handleSensitivity} />
                <div class="leverage_item">ATR Period</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={atr_period}
                onChange={handleAtrperiod} />
              </div>

              <div className="leverage_container">
                <div class="leverage_item">진입 기준 시간봉</div>
                <select className="select_samaria" value={entry_candle} onChange={handleEntryCandle}>
                <option value="1m">1 분봉</option>
                <option value="3m">3 분봉</option>
                <option value="5m">5 분봉</option>
                <option value="15m">15 분봉</option>
                <option value="30m">30 분봉</option>
                <option value="1h">1 시간봉</option>
                <option value="4h">4 시간봉</option>
                </select>
                <div class="leverage_item">UT 진입 기준</div>
                <select className="select_samaria" value={candle_type_entry} onChange={handleCandleTypeEntry}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
                <div class="leverage_item">UT 진입 신호 </div>
                <select className="select_samaria" value={entry_checking} onChange={handleEntryEntryChecking}>
                <option value="-1">발생</option>
                <option value="-2">확정</option>
                </select>
              </div>

              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item" >정리기준</div>
                  <select className="select_samaria" value={close_type} onChange={handleCloseType}>
                  <option value="kp">킨포인트</option>
                  <option value="ut">UT신호</option>
                  <option value="pin">PIN신호</option>
                  </select>
                <div class="leverage_item" disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>Sensitivity</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={sensitivity_close}
                disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleSensitivityClose} />
                <div class="leverage_item" disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>ATR Period</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={atr_period_close}
                disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleAtrperiodClose} />
              </div>

              <div className="leverage_container">
                <div class="leverage_item">정리 기준 시간봉</div>
                  <select className="select_samaria" value={close_candle} onChange={handleCloseCandle}>
                  <option value="1m">1 분봉</option>
                  <option value="3m">3 분봉</option>  
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  </select>
                <div class="leverage_item"disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>UT 정리 기준</div>
                <select className="select_samaria" value={candle_type_close}
                  disabled={(close_type === 'kp')}
                    style={{
                      filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleCandleTypeClose}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
                <div class="leverage_item" disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>UT 정리 신호</div>
                <select className="select_samaria" value={close_checking}
                  disabled={(close_type === 'kp')}
                  style={{
                    filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleCloseChecking}>
                <option value="-1">발생</option>
                <option value="-2">확정</option>
                </select>
              </div>

            <div className="line"></div>
            </div>

            <div className="leverage_container"></div>
            <div className="button_benefit_leverage">
                <button onClick={() => onClickStart()} className="bottomButton_sp_lever">
                매매 시작
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickBenefit_stop(symbol)} disabled={benefit_stop === 1 || trade_start === 0 || benefit_stop === '1' || trade_start === '0'} className="button_benefit_c_lever">
                익절 후 정리
                </button>
                <button onClick={() => onClickBenefit_cancel(symbol)} disabled={benefit_stop === '0' || benefit_stop === 0} className="button_benefit_c_lever">
                취 소
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickCurrentCoin_stop(symbol)} disabled={(symbol === 'default' && trade_start === 0 &&  benefit_stop === 0) || (symbol === 'default' && trade_start === '0' &&  benefit_stop === '0') || setlevel <= 7} className="bottomButton_sp_lever">
                현재 코인 정리
                </button>
                {/* <button onClick={() => onClickAllCoin_stop()} disabled={symbol === 'default' && setlevel <= 7} className="button_benefit_c_lever">
                All symbol close
                </button> */}
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                로그아웃
                </button>
             </div>
          </div>


          <div className="column_leverage">
              <div className="list_box_title_lever">진입중인 코인 리스트</div>
              <ul className="list_box_lever">
                {e_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
          </div>

          <div className="column_leverage">
            <div className="list_box_title_lever">익절 후 정리 리스트</div>
              <ul className="list_box_lever">
                {w_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
    );
}